export default function getUtc(temp: Date): Date {
  var now_utc = Date.UTC(temp.getFullYear(), temp.getMonth(), temp.getDate(), temp.getHours(), temp.getMinutes(), temp.getSeconds());
  return new Date(now_utc);
}
